export default {
  GENERAL: 'general',
  COMMUTATOR: 'commutator',
  COMMUTATOR_PARAMETERS: 'commutator-parameters',
};
